import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + heroSlides.length) % heroSlides.length);
  };

  const slide = heroSlides[active];

  return (
    <section className="relative w-full">
      <div className="relative h-[420px] w-full overflow-hidden md:h-[600px]">
        {heroSlides.map((item, index) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={item.image}
              alt={`${item.title} 影视海报`}
              title={`${item.title} 影视资源`}
              className="h-full w-full object-cover"
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/50 to-primary-950/20"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 via-transparent to-transparent"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
            <div key={slide.id} className="animate-fade-up max-w-xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
                <i className="ri-fire-fill leading-none"></i>
                正在热映
              </span>
              <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                {slide.title}
              </h1>
              <p className="mt-3 text-base text-background-100 md:text-lg">{slide.tagline}</p>
              <p className="mt-2 text-sm text-background-300">{slide.meta}</p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${slide.id}`}
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-information-line text-base leading-none"></i>
                  查看详情
                </Link>
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-apps-2-line text-base leading-none"></i>
                  进入分类
                </Link>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-primary-950/70 md:left-6 md:h-11 md:w-11"
        >
          <i className="ri-arrow-left-s-line text-xl leading-none md:text-2xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-primary-950/70 md:right-6 md:h-11 md:w-11"
        >
          <i className="ri-arrow-right-s-line text-xl leading-none md:text-2xl"></i>
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((item, index) => (
            <button
              key={item.id}
              type="button"
              aria-label={`切换到 ${item.title}`}
              onClick={() => setActive(index)}
              className={`h-1.5 rounded-full transition-all ${
                index === active ? "w-8 bg-accent-500" : "w-3 bg-background-50/50 hover:bg-background-50/80"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}